import { __require as E } from "../../ms/index.mjs";
function O(a) {
  e.debug = e, e.default = e, e.coerce = k, e.disable = y, e.enable = m, e.enabled = C, e.humanize = E(), e.destroy = w, Object.keys(a).forEach((t) => {
    e[t] = a[t];
  }), e.names = [], e.skips = [], e.formatters = {};
  function g(t) {
    let n = 0;
    for (let r = 0; r < t.length; r++)
      n = (n << 5) - n + t.charCodeAt(r), n |= 0;
    return e.colors[Math.abs(n) % e.colors.length];
  }
  e.selectColor = g;
  function e(t) {
    let n, r = null, i, p;
    function l(...o) {
      if (!l.enabled)
        return;
      const s = l, u = Number(new Date()), x = u - (n || u);
      s.diff = x, s.prev = n, s.curr = u, n = u, o[0] = e.coerce(o[0]), typeof o[0] != "string" && o.unshift("%O");
      let c = 0;
      o[0] = o[0].replace(/%([a-zA-Z%])/g, (f, j) => {
        if (f === "%%")
          return "%";
        c++;
        const b = e.formatters[j];
        if (typeof b == "function") {
          const v = o[c];
          f = b.call(s, v), o.splice(c, 1), c--;
        }
        return f;
      }), e.formatArgs.call(s, o), (s.log || e.log).apply(s, o);
    }
    return l.namespace = t, l.useColors = e.useColors(), l.color = e.selectColor(t), l.extend = h, l.destroy = e.destroy, Object.defineProperty(l, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => r !== null ? r : (i !== e.namespaces && (i = e.namespaces, p = e.enabled(t)), p),
      set: (o) => {
        r = o;
      }
    }), typeof e.init == "function" && e.init(l), l;
  }
  function h(t, n) {
    const r = e(this.namespace + (typeof n > "u" ? ":" : n) + t);
    return r.log = this.log, r;
  }
  function m(t) {
    e.save(t), e.namespaces = t, e.names = [], e.skips = [];
    let n;
    const r = (typeof t == "string" ? t : "").split(/[\s,]+/), i = r.length;
    for (n = 0; n < i; n++)
      r[n] && (t = r[n].replace(/\*/g, ".*?"), t[0] === "-" ? e.skips.push(new RegExp("^" + t.slice(1) + "$")) : e.names.push(new RegExp("^" + t + "$")));
  }
  function y() {
    const t = [
      ...e.names.map(d),
      ...e.skips.map(d).map((n) => "-" + n)
    ].join(",");
    return e.enable(""), t;
  }
  function C(t) {
    if (t[t.length - 1] === "*")
      return !0;
    let n, r;
    for (n = 0, r = e.skips.length; n < r; n++)
      if (e.skips[n].test(t))
        return !1;
    for (n = 0, r = e.names.length; n < r; n++)
      if (e.names[n].test(t))
        return !0;
    return !1;
  }
  function d(t) {
    return t.toString().substring(2, t.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function k(t) {
    return t instanceof Error ? t.stack || t.message : t;
  }
  function w() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return e.enable(e.load()), e;
}
var $ = O;
export {
  $ as default
};
//# sourceMappingURL=common.mjs.map
